<template>
  <div class="positionCoefficient">
    <!-- <h1>This is an positionCoefficient page</h1> -->
    <!-- 岗位发放系数 -->
    <el-form class="searchClass mt10" :inline="true" :model="searchList" label-width="100px" label-position="top">
      <el-form-item label="年份">
        <!-- <el-select v-model="searchList.year" placeholder="请选择年份"> -->
          <!-- <el-option :label="item.label" :value="item.label" v-for="(item, index) in year" :key="index"></el-option> -->
        <!-- </el-select> -->
        <el-date-picker v-model="searchList.year" type="year" value-format="yyyy" placeholder="请选择年份"></el-date-picker>
      </el-form-item>
      <el-form-item label="季度">
        <el-select v-model="searchList.quarter" clearable placeholder="请选择季度">
          <!-- <el-option :label="item.label" :value="item.label" v-for="(item, index) in quarter" :key="index"></el-option> -->
          <el-option label="Q1" value="Q1"></el-option>
          <el-option label="Q2" value="Q2"></el-option>
          <el-option label="Q3" value="Q3"></el-option>
          <el-option label="Q4" value="Q4"></el-option>
          <el-option label="Yearly" value="Yearly"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="渠道" v-if="roles.indexOf('Category BU') === -1">
        <el-select v-model="searchList.channel" @change="changeChannel" clearable placeholder="请选择渠道">
          <el-option :label="item.label" :value="item.label" v-for="(item, index) in channel" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="岗位">
        <el-select v-model="searchList.roleNm" clearable placeholder="请选择岗位">
          <el-option :label="item.label" :value="item.label" v-for="(item, index) in roleNm" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <div>
        <el-form-item>
          <el-button type="primary" @click="search()" plain>搜 索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="downloadExcel()">下载</el-button>
        </el-form-item>
      </div>
    </el-form>
    <el-table :data="data" v-loading="fullscreenLoading" height="500" border header-cell-class-name="headerStyle" cell-class-name="cellStyle">
      <el-table-column width="180" prop="versionName" label="周期"></el-table-column>
      <!-- <el-table-column prop="year" label="年份"></el-table-column> -->
      <!-- <el-table-column prop="quarter" label="季度"></el-table-column> -->
      <!-- <el-table-column prop="channel" label="渠道"></el-table-column> -->
      <el-table-column width="220"  prop="roleNm" label="岗位名称"></el-table-column>
      <el-table-column prop="cntTarget" label="岗位数量"></el-table-column>
      <el-table-column prop="cntAct" label="计奖岗位数量"></el-table-column>
      <el-table-column prop="cntAct50" label="0-50"></el-table-column>
      <el-table-column prop="cntAct80" label="50-80"></el-table-column>
      <el-table-column prop="cntAct100" label="80-100"></el-table-column>
      <el-table-column prop="cntAct120" label="100-120"></el-table-column>
      <el-table-column prop="cntAct140" label="120-140"></el-table-column>
    </el-table>
    <el-pagination class="mt20 right_m" @current-change="pagesChange" :current-page="currentPage" :page-size=size layout="total, prev, pager, next, jumper" :total=total></el-pagination>
  </div>
</template>

<script>
export default {
  name: 'positionCoefficient',
  data () {
    return {
      // 用户信息
      userInfo: '',
      roles: [],
      data: [],
      // 筛选条件
      // year: [],
      // quarter: [],
      channel: [],
      roleNm: [],
      // 搜索
      searchList: {
        year: null,
        quarter: null,
        channel: null,
        roleNm: null
      },
      // 分页
      pages: 0,
      total: 0,
      size: 0,
      currentPage: 0,
      fullscreenLoading: false // 遮罩层
    }
  },
  created () {
    this.getSessionRoles()
  },
  mounted () {
    this.getData()
    this.getChannelList()
  },
  methods: {
    // 获取数据
    getData (param) {
      this.data = []
      this.fullscreenLoading = true
      if (!param) {
        this.searchList.pageNum = 1
        this.searchList.pageSize = 20
      }
      this.$http.post(this.API.positionCoefficient, this.searchList).then((res) => {
        // console.log(res)
        let data = res.data
        this.data = data.data.records
        // 分页
        this.pages = data.data.pages
        this.total = data.data.total
        this.size = data.data.size
        this.currentPage = data.data.current
        if (!param) {
          // 筛选项
          // let year = []
          // let quarter = []
          // let channel = []
          let roleNm = []
          // this.year = this.FilterRendering(data.data.years, year)
          // this.quarter = this.FilterRendering(data.data.quarters.sort(), quarter)
          // this.channel = this.FilterRendering(data.data.channels, channel)
          this.roleNm = this.FilterRendering(data.data.roleNms, roleNm)
        }
        this.fullscreenLoading = false
      }).catch(() => {
        // console.log(err)
        this.fullscreenLoading = false
      })
    },
    // 获取渠道列表
    getChannelList () {
      this.channel = []
      this.$http.get(this.API.channelList).then(res => {
        // console.log(res)
        let data = res.data
        let channel = []
        data.data.forEach(ele => {
          channel.push({
            label: ele.name,
            value: ele.name
          })
        })
        this.channel = channel
      })
    },
    // 筛选--渠道筛选岗位
    changeChannel (v) {
      // console.log(v)
      if (this.searchList.roleNm !== null) {
        this.searchList.roleNm = null
      }
      for (let key in this.searchList) {
        if (this.searchList[key] === '') {
          this.searchList[key] = null
        }
      }
      this.roleNm = []
      this.$http.post(this.API.positionCoefficient, this.searchList).then((res) => {
        let data = res.data
        let roleNm = []
        this.roleNm = this.FilterRendering(data.data.roleNms, roleNm)
      })
    },
    // 搜索
    search () {
      this.searchList.pageNum = 1
      this.searchList.pageSize = this.size
      for (let key in this.searchList) {
        if (this.searchList[key] === '') {
          this.searchList[key] = null
        }
      }
      this.getData(this.searchList)
    },
    // 下载
    downloadExcel () {
      this.$http.post(this.API.downloadPositionCoefficient, this.searchList, { responseType: 'blob' }).then(res => {
        // console.log(res)
        let data = res.data
        let responseType = data.type || null
        if (responseType.includes('application/json')) {
          let reader = new FileReader()
          reader.onload = (e) => {
            // console.log(e)
            let msg = JSON.parse(e.target.result).msg
            if (msg) {
              this.$message.error(msg)
            } else {
              this.$message.error('接口调用失败！')
            }
          }
          reader.readAsText(data)
        } else {
          let blob = new Blob([data], { type: data.type })
          let downloadElement = document.createElement('a')
          let href = window.URL.createObjectURL(blob) // 创建下载的链接
          downloadElement.href = href
          downloadElement.download = '岗位发放系数' + '.xls' // 下载后文件名
          document.body.appendChild(downloadElement) // 添加元素
          downloadElement.click() // 点击下载
          document.body.removeChild(downloadElement) // 下载完成移除元素
          window.URL.revokeObjectURL(href) // 释放掉blob对象
          this.$message.success('下载成功！')
        }
      })
    },
    // 翻页
    pagesChange (v) {
      this.searchList.pageNum = v
      this.searchList.pageSize = this.size
      for (let key in this.searchList) {
        if (this.searchList[key] === '') {
          this.searchList[key] = null
        }
      }
      this.getData(this.searchList)
    },
    // 清空搜索项
    resetSearchList () {
      this.searchList = {
        year: null,
        quarter: null,
        channel: null,
        roleNm: null
      }
    },
    // 处理筛选项
    FilterRendering (arr, fieldArr) {
      if (arr !== null) {
        arr.forEach(ele => {
          fieldArr.push({
            label: ele,
            value: ele
          })
        })
        return fieldArr
      } else {
        return []
      }
    },
    // 获取session用户信息
    getSessionRoles () {
      this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
      if (this.userInfo !== null) {
        let arr = this.userInfo.roles
        let roles = []
        if (arr != null && arr.length > 0) {
          arr.forEach(ele => {
            roles.push(ele.roleName)
          })
        }
        this.roles = roles
      }
    }
  }
}
</script>

<style lang="less" scoped>

</style>
